import { FC, SetStateAction, useEffect, useRef, useState } from 'react';
import { CustomTable } from '../../shared';
import Status, { Rating, TableActions } from '../../shared/StatusUtility';
import {
  userBookingsColumnData,
  userBookingsTableColumnExtensions
} from '../../../utils/mockUpData';
import { useAppDispatch } from '../../../redux/store';
import { userBookingsAPI } from '../../../redux/features/bookings/bookingsSlice';
import { formatDate } from '../../../utils/validator';
import { BookingUtils } from './utils';

interface BookingListProps {
  row?: any;
}

export const BookingsList: FC<BookingListProps> = ({ row }) => {
  //REDUX
  const dispatch = useAppDispatch();
  // STATES
  const [activePopover, setActivePopover] = useState<number | null>(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const popoverRef = useRef<HTMLDivElement | null>(null);

  // Toggle Popover
  const handleToggle = (index: number) => {
    setActivePopover(prev => (prev === index ? null : index));
  };

  //  DATA PROVIDERS
  const dataProviders = [
    {
      columnName: ['status'],
      func: (restProps: any) => Status(restProps?.row?.status, 'Active', 'Inactive')
    },
    {
      columnName: ['rating'],
      func: (restProps: any) => <Rating row={restProps} />
    },
    {
      columnName: ['action'],
      func: (restProps: any) => (
        <TableActions
          restProps={restProps}
          children={() => <BookingUtils row={restProps} />}
          isActive={Boolean(activePopover === restProps?.row?.idx)}
          onToggle={handleToggle}
          placement='right-12 top-7'
          height='max-h-60'
          ref={popoverRef}
        />
      )
    }
  ];

  // GET USER BOOKINGS
  const getUserBookings = async (userId: string) => {
    setLoading(true);
    const response = await dispatch(userBookingsAPI(userId));
    if (response?.meta?.requestStatus === 'fulfilled') {
      const list = response?.payload?.data;
      if (list?.length > 0) {
        setRows(() => {
          return list?.map((item: any, idx: number) => ({
            idx: idx + 1,
            _id: item?._id,
            bookingUID: item?.bookingUID,
            bookingDate: formatDate(item?.bookingDate, 'MM/DD/YY, hh:mm A'),
            status: item?.status,
            startTime: item?.startTime,
            endTime: item?.endTime,
            duration: item?.duration,
            address: item?.address,
            total: item?.total,
            subTotal: item?.subTotal,
            stripeFee: item?.stripeFee,
            images: item?.images,
            note: item?.note,
            ratings: item?.ratings[0],
            ratingDescrition: item?.ratings[0]?.description
          }));
        });
      }
      setLoading(false);
    }
    if (response?.meta?.requestStatus === 'rejected') {
      setLoading(false);
    }
    return response;
  };

  useEffect(() => {
    if (row) {
      getUserBookings(row?.id);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <CustomTable
      loading={loading}
      rows={rows?.length > 0 ? rows : []}
      columns={userBookingsColumnData}
      tableColumnExtensions={userBookingsTableColumnExtensions}
      selectedIds={selectedIds}
      setSelectedIds={(selectedIds: SetStateAction<never[]>) => setSelectedIds(selectedIds)}
      dataProviders={dataProviders}
    />
  );
};
